function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 9.48,
  y: 7.5,
  width: 5,
  height: 5,
  rx: 2.5,
  stroke: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.481 18a.541.541 0 00.525-.5 5 5 0 019.95 0c.028.276.249.5.525.5a.47.47 0 00.48-.5A6 6 0 006 17.5a.47.47 0 00.48.5z",
  fill: "currentColor"
});

function SvgMyAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgMyAccount;